const IOT_BASE_URL =
  "https://hvh99xaxi0.execute-api.us-west-2.amazonaws.com/prod"; //"https://iot-solarbase.arnergy.com";

export default { IOT_BASE_URL };



// WEBPACK FOOTER //
// ./src/utils/constants.js